import sideGrid from "./sideGrid.component";

const sideGridModule = angular
  .module("app.components.sideGrid", [])
  .component("sideGrid", sideGrid);

export default sideGridModule;



// WEBPACK FOOTER //
// ./src/components/sideGrid/sideGrid.module.js